import classes from "./login-content.module.scss";

import { useCallback } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@honeycomb/ui";
import { LogIn, Mail, Phone } from "lucide-react";

export const LoginContentForm = () => {
  const { loginWithRedirect } = useAuth0();

  const handleRedirectSubmit = useCallback(
    (connectionType?: "sms" | "email") => {
      return () => {
        loginWithRedirect({
          authorizationParams: {
            connection: connectionType,
          },
        });
      };
    },
    [loginWithRedirect]
  );

  return (
    <form className={classes["login-form"]}>
      <div className={classes["login-actions"]}>
        <Button type="primary" data-cy="log-in-email" onClick={handleRedirectSubmit("email")}>
          <Mail /> Email log in
        </Button>
        <Button data-cy="log-in-sms" onClick={handleRedirectSubmit("sms")}>
          <Phone /> Phone log in
        </Button>
        <Button type="text" data-cy="log-in-password" onClick={handleRedirectSubmit()}>
          <LogIn /> Password log in
        </Button>
      </div>
    </form>
  );
};
